module.exports = 'This text exported from temp-test-module'

